import React, { useContext } from 'react';
import {
	CircularProgress,
	FormControl,
	FormHelperText,
	MenuItem,
	Select,
} from '@material-ui/core';
import { publicado } from 'helpers/options';
import QuestionContext from '../../screens/ListarQuestoes/providers/QuestionProvider';

interface Props {
	name: string;
	value: string | boolean;
	onChange: any;
	error?: boolean | undefined;
	helperText?: string | false | undefined;
	disabled?: boolean;
	variables?: any;
}

const SelectPublicado: React.FC<Props> = ({
	name,
	value,
	onChange,
	error,
	helperText,
	disabled = false,
}) => {
	const { loading } = useContext(QuestionContext);

	if (loading) {
		return <CircularProgress />;
	}

	return (
		<FormControl variant="outlined" error={error} className="mr-2">
			{onChange && (
				<Select
					name={name}
					displayEmpty
					value={value}
					onChange={onChange}
					disabled={disabled}
				>
					<MenuItem value="">Data publicação</MenuItem>
					{publicado.map(option => (
						<MenuItem key={option.value} value={option.value}>
							{option.label}
						</MenuItem>
					))}
				</Select>
			)}

			<FormHelperText>{helperText}</FormHelperText>
		</FormControl>
	);
};

export default SelectPublicado;
